import { defineStore } from 'pinia';
import type { ProductsExtraGuaranteeState } from '~~/types/vuex/ProductsExtraGuarantee';

export const productsExtraGuaranteeStore = defineStore('productsExtraGuarantee', {
  state: () => ({ productsExtraGuarantee: null as ProductsExtraGuaranteeState['productsExtraGuarantee'] | null }),
  actions: {
    setProducts(payload: ProductsExtraGuaranteeState['productsExtraGuarantee'] | null) {

      this.productsExtraGuarantee = payload; 

    },
  },
});
